$(document).ready(function(){
  $(".cart__quantity-selector").click(function(){
  
     var quantity=$(this).val();
   // alert(quantity);
    
    
    var price=$(this).parent().prev().text();
    //alert(price);

    var p=price.split("Rs.");
    var n=p[1].replace(",","");
   
    
    var total=n*quantity;
    var r="Rs. ";
    var f=r.concat(total);
  //  alert(f);
    $(this).parent().next().text(f);
   
    
    var str='';
    $( ".demo" ).each(function( index ) {
  		var data=$(this).html().trim().split(" ");
     str=str+"+"+data[1].replace(",","");  
      
});
    
  var fprice=eval(str.substr(1));
    var sub= $(".h5.cart__subtotal").text(fprice);
    
  });
  
  
});

